<template>
    <div class="customers-stylesheet">
        <header class="page__top">
            <h1 v-t="'crm.stylesheet.title'"></h1>
            <div class="customers-stylesheet-page__toolbar">
                <WithGlobalPermission v-if="schema" permission="CustomerStyleRule.create">
                    <StylesheetCreate
                        :schema="schema.create"
                        :customer="filters.customer"
                        @submit="createRule"
                    />
                </WithGlobalPermission>
            </div>
        </header>
        <PaginatedResource
            ref="stylesheetResource"
            :fetch-method="fetchStylesheet"
            :filter-fields="filters"
            :sorting-fields="sortBy"
        >
            <template
                #default="{ loading, resource, isEmpty, notFound, canLoadMore, loadMore, sort }"
            >
                <div class="customers-stylesheet__paginated">
                    <Spinner v-if="loading" />
                    <StylesheetResults
                        :schema="schema"
                        :items="resource"
                        :loading="loading"
                        :is-empty="isEmpty"
                        :not-found="notFound"
                        :sort-by="sortBy"
                        @sort="sort"
                        @updateRule="updateRule"
                        @deleteRule="deleteRule"
                    />

                    <div v-if="canLoadMore" class="customers-stylesheet__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </div>
</template>

<script>
import {
    fetchSchema,
    fetchStylesheet,
    deleteStylRule,
    updateStyleRule,
    createStyleRule,
} from '../../api/stylesheet';
import { StylesheetCreate, StylesheetResults } from '@/stylesheet/components';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { WithGlobalPermission } from '@speechki-frontend/core/auth/components';

export default {
    name: 'CustomersStylesheet',
    components: {
        Spinner,
        PaginatedResource,
        StylesheetCreate,
        StylesheetResults,
        WithGlobalPermission,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
        sortBy: {
            type: Array,
            default: () => ['id', 'target', 'explanation'],
        },
    },
    data() {
        return {
            schema: undefined,
        };
    },
    async created() {
        try {
            await this.fetchSchema();
        } catch (e) {
            console.log(e);
        }
    },
    methods: {
        fetchStylesheet,
        refetchStylesheet() {
            this.$refs.stylesheetResource.fetch();
        },
        async fetchSchema() {
            this.schema = await fetchSchema(this.filters);
        },
        async createRule(data) {
            await createStyleRule(data);
            this.refetchStylesheet();
        },
        async updateRule(data) {
            const { id } = data;
            await updateStyleRule(id, data);
            this.refetchStylesheet();
        },
        async deleteRule({ id }) {
            await deleteStylRule(id);
            this.refetchStylesheet();
        },
    },
};
</script>
